/**
 * Made to match the Skapa InlineMessageVariant type.
 */
var InlineMessageLayoutEnum;
(function (InlineMessageLayoutEnum) {
    InlineMessageLayoutEnum["positive"] = "positive";
    InlineMessageLayoutEnum["informative"] = "informative";
    InlineMessageLayoutEnum["negative"] = "negative";
    InlineMessageLayoutEnum["cautionary"] = "cautionary";
})(InlineMessageLayoutEnum || (InlineMessageLayoutEnum = {}));
export default InlineMessageLayoutEnum;
//# sourceMappingURL=InlineMessageLayoutEnum.js.map